import request from './request';

function apiCallWrapper(apiCall) {
  // this is a convenience wrapper targetted for
  // tm apis we simply catch any swallow them and return
  // a consistent response which can be fit into the
  // if else pattern reducing branching.
  return async function (...args) {
    try {
      return await apiCall(...args);
    } catch (error) {
      return {
        code: 1,
        message: error?.message,
        result: error?.data,
      };
    }
  };
}

export const createLandingPage = apiCallWrapper((data) => {
  return request({
    url: `/landing-pages`,
    method: 'POST',
    data,
  });
});

export const getLandingPages = apiCallWrapper((mango) => {
  return request({
    url: `/landing-pages?${mango ? `mango=${mango}` : ''}`,
    method: 'GET',
  });
});

export const getLandingPage = apiCallWrapper((landingPageId) => {
  return request({
    url: `/landing-pages/${landingPageId}`,
    method: 'GET',
  });
});

export const uploadFileStatic = apiCallWrapper((file) => {
  return request({
    url: `/upload-file-static`,
    method: 'POST',
    data: file,
  });
});

export const uploadBase64Image = apiCallWrapper((data) => {
  return request({
    url: `/upload-file-base64-static`,
    method: 'POST',
    data,
  });
});

export const initializeEditor = (mango, pageId) => {
  if (mango) {
    return request({
      url: `/landing-pages/initialize-editor?mango=${mango}`,
    });
  }
  return request({
    url: `/landing-pages/initialize-editor?pageId=${pageId}`,
  });
};

export const updateLandingPage = apiCallWrapper((landingPageId, data) => {
  return request({
    url: `/landing-pages/${landingPageId}`,
    method: 'PUT',
    data,
  });
});

export const publishLandingPage = apiCallWrapper(
  (landingPageId, unPublishState) => {
    return request({
      url: `/landing-pages/${landingPageId}/publish${
        unPublishState ? `?publishState=false` : ''
      }`,
      method: 'PUT',
    });
  }
);
